import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Iter 104c — Swallow the benign "ResizeObserver loop completed with
// undelivered notifications" browser warning before it reaches CRA's
// dev error overlay.  This warning is informational (browsers fire it
// when nested layout updates happen inside a ResizeObserver callback,
// which Radix Popover / Recharts / react-virtuoso routinely trigger)
// and never indicates a real bug — but CRA's overlay treats EVERY
// uncaught `error` event as fatal and full-screens it, which blocks
// all user interaction. The accepted upstream workaround is to
// stopImmediatePropagation before the overlay's handler sees it.
const _ro_msgs = new Set([
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
]);
window.addEventListener("error", (e) => {
  if (_ro_msgs.has(e?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message;
  if (msg && _ro_msgs.has(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
